import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {safeLocalStorageGet, safeLocalStorageSet} from '../lib/web-storage.js';

import {
    getIsShowingWithId
} from '../reducers/project-state';

class ProjectWatcher extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'waitForUpdate'
        ]);

        this.state = {
            waiting: false
        };
        
        // 자동저장 타이머
        this._autoSaveTimer = null;
    }

    componentDidMount () {
        // 앱 시작 시 localStorage에서 불러오기
        try {
            const saved = safeLocalStorageGet('xrobo_autosave');
            if (saved && this.props.vm) {
                this.props.vm.loadProject(
                    new Uint8Array(JSON.parse(saved)).buffer
                ).catch(e => console.log('autosave load failed:', e));
            }
        } catch (e) {
            console.log('autosave load failed:', e);
        }
    }

    componentDidUpdate (prevProps) {
            console.log('projectChanged:', this.props.projectChanged); 
        if (this.state.waiting && this.props.isShowingWithId && !prevProps.isShowingWithId) {
            this.fulfill();
        }
        
        // 프로젝트 변경 감지 → 자동저장
        if (this.props.projectChanged && !prevProps.projectChanged) {
            this.scheduleAutoSave();
        }
    }

    componentWillUnmount () {
        if (this._autoSaveTimer) clearTimeout(this._autoSaveTimer);
    }

    scheduleAutoSave () {
        // 2초 디바운스
        if (this._autoSaveTimer) clearTimeout(this._autoSaveTimer);
        this._autoSaveTimer = setTimeout(() => {
            this.doAutoSave();
        }, 2000);
    }

    doAutoSave () {
        try {
            if (this.props.vm) {
                this.props.vm.saveProjectSb3().then(blob => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const arr = Array.from(new Uint8Array(reader.result));
                        safeLocalStorageSet('xrobo_autosave', JSON.stringify(arr));
                        console.log('autosave complete');
                    };
                    reader.readAsArrayBuffer(blob);
                });
            }
        } catch (e) {
            console.log('autosave failed:', e);
        }
    }

    fulfill () {
        this.props.onDoneUpdating();
        this.setState({
            waiting: false
        });
    }

    waitForUpdate (isUpdating) {
        if (isUpdating) {
            this.setState({
                waiting: true
            });
        } else {
            this.fulfill();
        }
    }

    render () {
        return this.props.children(
            this.waitForUpdate
        );
    }
}

ProjectWatcher.propTypes = {
    children: PropTypes.func,
    isShowingWithId: PropTypes.bool,
    onDoneUpdating: PropTypes.func,
    projectChanged: PropTypes.bool,
    vm: PropTypes.object
};

ProjectWatcher.defaultProps = {
    onDoneUpdating: () => {}
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        isShowingWithId: getIsShowingWithId(loadingState),
        projectChanged: state.scratchGui.projectChanged,
        vm: state.scratchGui.vm
    };
};

const mapDispatchToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectWatcher);
